import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../api-services/api-service'; 
import axios from 'axios';

export const loginAdmin = createAsyncThunk(
  'admin/login',
  async ({ userName, password }, { rejectWithValue }) => {
    try {
      const data = await apiService.login(userName, password);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    adminData: JSON.parse(localStorage.getItem('admin')) || null, // Load from localStorage
    loading: false,
    error: null,
  },
  reducers: {
    logout(state) {
      state.adminData = null;
      state.error = null;
      localStorage.removeItem('admin'); // Remove from localStorage on logout

       delete axios.defaults.headers.common['Authorization'];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.adminData = action.payload;
        state.error = null;
        localStorage.setItem('admin', JSON.stringify(action.payload)); // Save to localStorage
      })
      .addCase(loginAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout } = adminSlice.actions;
export default adminSlice.reducer;
